// extracted by mini-css-extract-plugin
export default {"submitMessage":"SuccessMessage_submitMessage__naabj","image":"SuccessMessage_image__qK7iF","text":"SuccessMessage_text__g9KW5"};